import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailers-filter-action_category_impression';

/**
 * Tracks filter view events

Param 1: Context string, e.g. Search
Param 2: list of filterKeys joined with ` ` separating each item
Param 3: list of position indices joined with ` ` separating each item (0-index)
 */
export function trackRetailersFilterActionCategoryImpression(
  context: string,
  filterKeys2: string,
  positions3: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { context, filterKeys2, positions3 },
  });
}
